import type { EpcProjectMembershipRow } from '../../../../services/epcProjectService';
import { isGovernanceRole } from './teamCapabilities';

/**
 * Default reporting line for a newly assigned Department Head (spec §3.2):
 * PMO member if present, else Project Head, else any other active governance
 * member. Undefined when the project has no active governance at all.
 */
export function resolveDefaultGovernanceApprover(
  memberships: readonly EpcProjectMembershipRow[],
): EpcProjectMembershipRow | undefined {
  const active = memberships.filter((m) => !m.inactive && isGovernanceRole(m.role));
  return (
    active.find((m) => m.role === 'pmo') ??
    active.find((m) => m.role === 'project_head') ??
    active[0]
  );
}
